<!-- Modal Holidays -->
<div class="modal fade rtl " id="holidaysModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title d-flex align-content-center text-dark" id="exampleModalLabel"> <span
                        class="ms-2">ثبت و ویرایش تعطیلات</span>
                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="col-12 d-flex flex-wrap justify-content-between m-1">
                    <div class="d-flex col-md-3 col-6  dirI form-group">
                        <span class="mt-2 me-2">سال: </span>
                        <select class="form-select col-auto pointer" id="holidayYear"
                            (change)="yearChanged.emit($event.target.value)">
                            <option *ngFor="let item of years" value="{{item}}">{{item | faNum}}</option>
                        </select>
                    </div>
                    <div class="col-md-2 col-6  dirI">
                        <button class="btn btn-outline-success" style="width: 100px;" (click)="addRequested.emit()">ثبت
                            &nbsp;<i class="fa fa-plus "></i></button>
                    </div>
                </div>
                <div class="p-1" *ngIf="holidays?.length > 0">
                    <table class="table table-striped dirI">
                        <thead class="">
                            <tr class="text-center">
                                <th scope="col" class=""># </th>
                                <th scope="col" class="">تاریخ</th>
                                <th scope="col" class="">روز</th>
                                <th scope="col" class="">نوع</th>
                                <th scope="col" class="">توضیحات</th>
                                <th scope="col" class=""></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="text-center f14" *ngFor="let item of holidays;let i=index">
                                <th class="text-dark">{{i+1 | faNum}}</th>
                                <th class="text-dark">{{item.strDate | faNum}}</th>
                                <th class="text-dark">{{item.strDayName | faNum}}</th>
                                <th class="text-dark">{{item.strTypeComment | faNum}}</th>
                                <th class="text-dark">{{item.strComment | faNum}}</th>
                                <th class="text-dark"><i (click)="deleteRequested.emit(item)"
                                        class="fa fa-trash fa-lg text-danger pointer"></i></th>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div *ngIf="holidays?.length < 1" class="d-flex justify-content-center align-items-center">
                    <span class="fw-bold text-dark f18">موردی یافت نشد</span>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary " data-bs-dismiss="modal">بستن <i
                        class="fa fa-close"></i></button>
            </div>
        </div>
    </div>
</div>
